import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartCreateCommentResponse } from './multiCartMappers'

type CreateCommentRequest = paths['/api/carts/multi-carts/{multiCartId}/items/{itemId}/comments']['post']['requestBody']['content']['application/json']
type CreateCommentResponse = paths['/api/carts/multi-carts/{multiCartId}/items/{itemId}/comments']['post']['responses']['201']['content']['application/json']

export async function createMultiCartComment(
  multiCartId: string,
  itemId: string,
  text: string,
): Promise<App.MultiCartComment> {
  return request.post<CreateCommentResponse, CreateCommentRequest>(
    `/api/carts/multi-carts/${multiCartId}/items/${itemId}/comments`,
    { text },
    { credentials: 'include' },
  ).then(mapMultiCartCreateCommentResponse)
}
